/* Custom Input Component to be used with Formik */
import React, { useMemo } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { Text, FormErrorMessage } from 'components/atoms';
import FieldArrayDnd from './FieldArrayDnd'

// this spacing is used below the error message, this makes the margin feel more natural
// when the error happears and disappears
const InputSpacingFix = styled.div`
  height: ${props => props.theme.spacing.m};
  width: 100%;
`;

const FieldArray = ({
  title,
  field,
  filemodule,
  isPeopleModule,
  form: { errors, setFieldValue },
  ...props
}) => {
  const isError = useMemo(() => errors[field.name], [errors, field.name]);

  const handleChange = value => {
    setFieldValue(field.name, value);
  };

  return (
    <Styles>
      {title && <Top><Text modifiers={['base']}>{title}</Text></Top>}
      <FieldArrayDnd
        onChange={handleChange}
        initialProps={field.value}
        filemodule={filemodule}
        isPeopleModule={isPeopleModule}
        {...props}
      />
      {isError && <FormErrorMessage>{errors[field.name]}</FormErrorMessage>}
      <InputSpacingFix />
    </Styles>
  );
};

FieldArray.propTypes = {
  title: PropTypes.string,
  filemodule: PropTypes.bool,
  isPeopleModule: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
    onBlur: PropTypes.func,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    isSubmitting: PropTypes.bool,
    isValid: PropTypes.bool,
    setFieldValue: PropTypes.func,
  }).isRequired,
};

FieldArray.defaultProps = {
  title: null,
  filemodule: true,
  isPeopleModule: false
};

const Top = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const Styles = styled.div`
  ${Text} {
    padding-bottom: ${props => props.theme.spacing.s};
  }
`;

export default FieldArray;
